module.exports = __webpack_public_path__ + "img/add-point.5a567f1b.svg";